// extracted by mini-css-extract-plugin
module.exports = {"block":"FaqItem_block__ERG4Y","question":"FaqItem_question__1C_Rp","open":"FaqItem_open__btKUC","answer":"FaqItem_answer__ABiAG"};